import { StyleSheet, Text, View } from "react-native";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { Dimensions } from "react-native";

const width = Dimensions.get("window").width; //width

export default function PaymentInfo({ creditData, moreInfo }) {
  return (
    <View style={styles.viewPaymentInfoData}>
      <View style={{alignItems: "center"}}>
        <Text style={styles.titleSecondary}>{"Total a pagar"}</Text>
        <View style={styles.viewValue}>
          <Text style={styles.info}>{"R$"}</Text>
          <Text style={styles.value}>{creditData.price.toString().replace(".", ",")}</Text>
        </View>
      </View>
      <View style={{ alignItems: "center", justifyContent: "center", marginHorizontal: 8 }}>
        <Icon
          name={"arrow-right-bold"}
          size={42}/>
      </View>
      <View style={{alignItems: "center"}}>
      <Text style={styles.titleSecondary}>{"Créditos"}</Text>
        <View style={styles.viewValue}>
          <Text style={styles.info}>{"R$"}</Text>
          <Text style={styles.value}>{creditData.coinValue.toString().replace(".", ",")}</Text>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  viewPaymentInfoData: {
    width: width,
    alignContent: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
  viewPaymentInfoTitle: {
    flexDirection: "row",
    alignItems: "center",
  },
  label: {
    fontSize: Fonts.FONT_SIZE_22,
    fontWeight: "bold",
    color: Colors.BLACK,
  },
  labelSecondary: {
    fontSize: Fonts.FONT_SIZE_18,
    color: Colors.BLACK,
  },
  info: {
    fontSize: Fonts.FONT_SIZE_22,
    color: Colors.BLACK,
    textAlignVertical: "bottom",
    marginBottom: 8,
  },
  value: {
    fontSize: 40,
    fontWeight: "bold",
    color: Colors.BLACK,
    textAlignVertical: "bottom",
  },
  viewValue: {
    flexDirection: "row",
    alignContent: "center",
    justifyContent: "center",
  },
  moreInfo: {
    textAlign: "center",
    fontSize: Fonts.FONT_SIZE_16,
    textDecorationLine: "underline",
    color: Colors.HYPERLINK,
  },
  titleSecondary: {
    color: Colors.BLACK,
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "bold",
  },
});
